import { AxiosResponse } from "axios";
import { http } from "../../../../src/utils";

export function getNextInvoiceNo(
  accountId: number,
  invoiceDate: string,
  docType?: 'DBN' | 'CRN'
) {
  let url = `/interim_bill/pvt/next_inv_no?account_id=${accountId}&invoice_date=${invoiceDate}`
  if (docType) {
    url += `&doc_type=${docType}`
  }
  return http.get(url).then((response: AxiosResponse) => response.data)
}